import React, { useState } from 'react';
import { AdminAuthProvider, useAdminAuth } from '../../contexts/AdminAuthContext';
import AdminLogin from './AdminLogin';
import AdminNav from './AdminNav';
import AdminDashboard from './AdminDashboard';
import AdminUsers from './AdminUsers';
import AdminUserDetail from './AdminUserDetail';

const AdminContent = () => {
  const { isAuthenticated, loading } = useAdminAuth();
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [selectedUserId, setSelectedUserId] = useState(null);

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <svg className="animate-spin h-12 w-12 text-purple-500 mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="text-gray-400">Loading admin console...</p>
        </div>
      </div>
    );
  }

  // Show login if not authenticated
  if (!isAuthenticated) {
    return <AdminLogin />;
  }

  // Handle navigation
  const handleNavigate = (page) => {
    setCurrentPage(page);
    setSelectedUserId(null);
  };

  // Handle viewing a user
  const handleViewUser = (userId) => {
    setSelectedUserId(userId);
    setCurrentPage('user-detail');
  };

  // Handle going back from user detail
  const handleBackFromUser = () => {
    setSelectedUserId(null);
    setCurrentPage('users');
  };

  // Render current page content
  const renderContent = () => {
    if (selectedUserId && currentPage === 'user-detail') {
      return (
        <AdminUserDetail 
          userId={selectedUserId} 
          onBack={handleBackFromUser}
        />
      );
    }

    switch (currentPage) {
      case 'dashboard':
        return <AdminDashboard />;
      case 'users':
        return <AdminUsers onViewUser={handleViewUser} />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <AdminNav 
        currentPage={currentPage} 
        onNavigate={handleNavigate}
      />
      <main className="max-w-7xl mx-auto px-4 py-6">
        {renderContent()}
      </main>
    </div>
  );
};

// Wrapper component that provides the auth context
const AdminApp = () => {
  return (
    <AdminAuthProvider>
      <AdminContent />
    </AdminAuthProvider>
  );
};

export default AdminApp;